import type { ApiClient, ApiService } from '@/lib/apiClient'
import { toApiError } from '@/lib/signalRApiService/utils'

type Response = {
  accessToken: string
  url: string
}

export type NegotiateApiService = ApiService<{}, Response>

const createNegotiateApiService =
  (apiClient: ApiClient): NegotiateApiService =>
  () =>
    apiClient
      .post('negotiate')
      .then(({ data }) => data)
      .catch(error => Promise.reject(toApiError(error)))

export default createNegotiateApiService
